<template>
    <div class="modal-container">
        <div class="create-modal-header ">
            <h3>Add Frequent Visitor</h3>
            <button @click=close>X</button>
        </div>
        <div class="modal-content">
            <div class="modal-intro-information">
                <label>Visitor First Name</label>
                <input ref="firstName" type="text" placeholder="First Name" class="modal-title" v-model="firstName" />
                <label>Visitor Last Name</label>
                <input ref="lastName" type="text" placeholder="Last Name" class="modal-title" v-model="lastName" />
            </div>
            <div class="modal-create-data">
                <div class="modal-create-data-item">
                    <p class="item-header">Resident*</p>
                    <div @mouseleave="showUnitsOptions = false" style="flex:2; z-index: 2; display: flex;"
                        ref="unitData">
                        <option-dropdown-select v-if="showUnitsOptions" class="search" style="top: 36px"
                            :options="residentOptions" :searchCallback="(data) => fetchResidents(data)"
                            :onOptionSelected="(option, event) => {
                                event.stopImmediatePropagation()
                                handleResidentSelected(option)
                            }" />
                        <button v-else-if="selectedResident != null" class="option-select-dropdown-button"
                            style="flex: 2; display: flex; align-items: center; justify-content: center;">
                            <p style="text-align: center;" @click="showUnitsOptions = !showUnitsOptions">
                                {{ selectedResident.name }}</p>
                        </button>
                        <button v-else class="option-select-dropdown-button"
                            style="flex: 2; display: flex; align-items: center; justify-content: center;">
                            <div style="display: flex; width: 100%; height: 100%; flex-direction: row; justify-content: flex-end; align-items: center;"
                                @click="showUnitsOptions = !showUnitsOptions">
                                <div style="padding-left: 8px; padding-right: 8px; font-weight: bolder;">
                                    <svg width="10" height="6" viewBox="0 0 10 6" fill="none">
                                        <path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                            </div>
                        </button>
                    </div>
                </div>
                <div class="modal-create-data-item">
                    <p>Visitor Relationship</p>
                    <div @mouseleave="showTypes = false" style="flex:2; z-index: 1; display: flex;" ref="type">
                        <option-dropdown-select v-if="showTypes" class="search" style="top: 36px" :options="mappedTypes"
                            :onOptionSelected="(option, event) => {
                                event.stopImmediatePropagation()
                                handleRelationshipSelected(option.value);
                                showTypes = false
                            }" />
                        <button v-else-if="selectedType != null" class="option-select-dropdown-button"
                            style="flex: 1; display: flex; align-items: center; justify-content: center;">
                            <p style="text-align: center;" @mousedown="showTypes = !showTypes">
                                {{ selectedType }}</p>
                        </button>
                        <button v-else class="option-select-dropdown-button"
                            style="flex: 1; display: flex; align-items: center; justify-content: center;">
                            <div style="display: flex; width: 100%; height: 100%; flex-direction: row; justify-content: flex-end; align-items: center;"
                                @mousedown="showTypes = !showTypes">
                                <div style="padding-left: 8px; padding-right: 8px; font-weight: bolder;">
                                    <svg width="10" height="6" viewBox="0 0 10 6" fill="none">
                                        <path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                            </div>
                        </button>
                    </div>
                </div>
                <div style="text-align: left;">
                    <input type="checkbox" id="permanent-checkbox" ref="permanent-checkbox" name="permanent-checkbox"
                        v-model="permanent" style="margin-top: 8px;">
                    <label style="color: black; margin-left: 18px; font-weight: bolder;"
                        for="permanent-checkbox">Permanent?</label>
                </div>
                <div v-if="!permanent" class="modal-create-data-section">
                    <p class="section-header">Key Active Time</p>
                    <!-- <div class="modal-create-data-item">
                            <p>Start Time</p>
                            <input ref="visitor-expiration" type="date" placeholder="Vistor Expiration Time"
                                class="visitor-modal-title" v-model="visitorExpiration" />
                        </div> -->
                    <div class="modal-create-data-item">
                        <p>Expiration Time</p>
                        <input ref="visitor-expiration" type="date" placeholder="Vistor Expiration Time"
                            class="visitor-modal-title" v-model="visitorExpiration" />
                    </div>
                </div>
                <!-- <div class="modal-create-data-section">
                        <p class="section-header">Send Key By:</p>
                        <div class="modal-checkbox-item">
                            <input type="checkbox" />
                            <div class="modal-create-data-item">
                                <p>Visitor Phone Number</p>
                                <input ref="resident-name" type="text" placeholder="Visitor Phone Number"
                                    class="modal-title" v-model="residentUid" />
                            </div>
                        </div>
                        <div class="modal-checkbox-item">
                            <input type="checkbox" />
                            <div class="modal-create-data-item">
                                <p>Visitor Email</p>
                                <input ref="license-plate" type="text" placeholder="Visitor Email" class="modal-title"
                                    v-model="licensePlate" />
                            </div>
                        </div>
                    </div> -->
            </div>
        </div>
        <div class="modal-footer">
            <button @click="() => createFrequentVisitor()">Create Visitor</button>
        </div>
    </div>
</template>
<script>

import EventBus from "../../eventBus.js";
import * as Constants from "../../js/constants.js";
import CTSRepository from "../../js/CTSRepository.js";
import OptionDropdownSelect from "../layout/OptionDropdownSelect.vue";

const NAME = Constants.CREATE_FREQUENT_VISITOR_MODAL

export default {
    props: ["userData", "organizationData"],
    components: {
        OptionDropdownSelect
    },
    data() {
        return {
            modalName: NAME,
            firstName: "",
            lastName: "",
            residentUid: "",
            relationship: "",
            businessName: "",
            visitorPhoneNumber: "",
            visitorEmail: "",
            licensePlate: "",
            visitorExpiration: null,
            showUnitsOptions: false,
            residentOptions: [],
            selectedResident: null,
            selectedType: null,
            showTypes: false,
            types: [
                "Family Member",
                "Friend",
                "Vendor",
            ],
            permanent: true,
            filteredTypes: null,
        }
    },
    beforeMount() {
        this.fetchResidents("")
    },
    methods: {
        show() {
            this.$modal.show(NAME);
        },
        close() {
            this.$emit('close')
        },
        beforeOpen(event) {
            console.log('Before Opening...', event)
        },
        notifyReload() {
            EventBus.$emit("refreshData")
        },
        async fetchResidents(data) {
            if (this.$props.organizationData == null) return
            new CTSRepository({
                organization_id: this.organizationData.organization_id
            }).fetchResidents(data).then(async (responseData) => {
                console.log("Search Data", responseData);
                let mappedData = await responseData.data.map(item => {
                    return {
                        key: `${item.first_name} ${item.last_name}${item.uid}`,
                        name: `${item.first_name} ${item.last_name}${item.address ? ` - ${item.address}` : ''}`,
                        value: item.uid
                    }
                });
                console.log("Mapped Data", mappedData);

                this.residentOptions = mappedData
                if(mappedData.length == 1) {
                    this.selectedResident = mappedData[0]
                }
            }).catch(() => {

            });
        },
        validateInputs() {
            let missingData = []
            // Visitor First Name
            let firstNameRef = this.$refs['firstName']
            if (this.firstName == "") {
                missingData.push("Missing Visitor First Name")
                firstNameRef.classList.add('invalid')
            }
            // Visitor Last Name
            let lastNameRef = this.$refs['lastName']
            if (this.lastName == "") {
                missingData.push("Missing Visitor Last Name")
                lastNameRef.classList.add('invalid')
            }

            // Selected Resident
            let unitDataRef = this.$refs['unitData']
            if (this.selectedResident == null) {
                missingData.push("Missing Resident")
                unitDataRef.classList.add('invalid')
            }

            // Expiration if Visitor is not Permanent
            let expirationRef = this.$refs['visitor-expiration']
            if (!this.permanent) {
                if (this.visitorExpiration == null) {
                    missingData.push("Missing Expiration for Temporary Visitor")
                    expirationRef.classList.add('invalid')
                }
            }

            if (missingData.length > 0) {
                alert(missingData.join('\n'))
                return false
            } else {
                return true
            }
        },
        async createFrequentVisitor() {
            //validateInputs
            if (!this.validateInputs()) {
                return
            }

            let status = "TEMPORARY"
            let expiration = new Date(this.visitorExpiration).getTime()
            if (this.permanent) {
                status = "PERMANENT"
                expiration = null
            }

            const body = {
                "visitorFirstName": this.firstName,
                "visitorLastName": this.lastName,
                "residentUid": this.selectedResident.value,
                "visitorType": "Frequent Visitor",
                "visitorEmail": "",
                "visitorPhoneNumber": "",
                "visitorRelationship": this.selectedType ? this.selectedType : "",
                "visitorLicensePlate": "",
                "visitorVendorName": "",
                "visitorExpiration": expiration,
                "visitorStatus": status,
                "reporter": this.$props.userData.sub
            }

            new CTSRepository(this.$props.organizationData).createVisitor(JSON.stringify(body)).then(response => {
                console.log("Create Visitor Response", response);
                this.notifyReload();
                this.close();
            }).catch(err => console.error(err))

        },
        handleResidentSelected(residentOption) {
            this.selectedResident = residentOption
            this.showUnitsOptions = false
        },
        handleRelationshipSelected(relationshipOption) {
            this.selectedType = relationshipOption
        }
    },
    computed: {
        mappedTypes: function () {
            const arrayToMap = this.filteredTypes ?? this.types
            return arrayToMap.map(item => {
                return {
                    name: item,
                    value: item
                }
            });
        },
    }
}
</script>
<style></style>